export const bugSnagKey: string = import.meta.env.VITE_BUGSNAG_API_KEY as string ?? null
